<div class="header">
    <h2>{{ 'news.modal.add.title' | translate }}</h2>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="news-add-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
    <div class="section">
        <h2>{{ 'news.fieldset.basic' | translate }}</h2>
        <app-form-input
            [control]="form.controls.title"
            [label]="'news.form.title' | translate"
            [placeholder]="'news.form.title.placeholder' | translate"
            inputId="title"
            testId="news-add-title"
        />
        <app-form-datepicker [control]="form.controls.date" [label]="'news.form.date' | translate" inputId="date" testId="news-add-date" />
    </div>

    <div class="section">
        <h2>{{ 'news.fieldset.content' | translate }}</h2>
        <app-form-textarea
            [control]="form.controls.description"
            [label]="'news.form.description' | translate"
            [placeholder]="'news.form.description.placeholder' | translate"
            inputId="description"
            [rows]="6"
            testId="news-add-description"
        />
    </div>
</form>

<div class="footer">
    <p-button [label]="'news.form.cancel' | translate" [outlined]="true" severity="secondary" data-test="news-add-cancel" (onClick)="close()" />
    <p-button
        type="submit"
        [label]="'news.form.create' | translate"
        [loading]="saving()"
        [disabled]="form.disabled"
        data-test="news-add-submit"
        (onClick)="onSubmit()"
    />
</div>
